import { render, staticRenderFns } from "./TradeShift.vue?vue&type=template&id=bffa166e"
import script from "./TradeShift.vue?vue&type=script&lang=ts"
export * from "./TradeShift.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports